import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Heart } from "lucide-react";

/**
 * Sticky floating Donate button — visible only on small screens.
 * Hidden on /eyes-of-hope and /admin pages (would be redundant).
 */
export default function MobileDonateFab() {
  const { pathname } = useLocation();
  const hidden =
    pathname.startsWith("/eyes-of-hope") ||
    pathname.startsWith("/admin") ||
    pathname.startsWith("/payment");
  if (hidden) return null;

  return (
    <Link
      to="/eyes-of-hope#donate"
      data-testid="mobile-donate-fab"
      aria-label="Donate to Eyes of Hope Foundation"
      className="xl:hidden fixed bottom-5 left-5 z-40 inline-flex items-center gap-2 pl-3.5 pr-4 py-3 bg-[#d4af37] hover:bg-[#c39f2f] text-[#0a0908] font-bold text-[12px] tracking-[0.2em] uppercase shadow-[0_10px_30px_-8px_rgba(212,175,55,0.6)] active:scale-95 transition-all duration-300 rounded-full"
    >
      <Heart size={16} className="fill-[#0a0908]" strokeWidth={2} aria-hidden="true" />
      Donate
    </Link>
  );
}
